import warrantyFrom from './warranty-form'

window['forms'] = {
    warrantyFrom,
}
$(function () {
    window['bsCustomFileInput'].init();
});
